import { createStore } from "vuex";

export default createStore({
  state: {
    userData: {},
    clientName: "",
    goodsData: [],
  },
  mutations: {},
  actions: {},
  modules: {},
});
